import forgetPass from './forget-pass.vue'

export default forgetPass
